import {
  PeppolItemDirection,
  PeppolItemDirectionConfig,
} from '../interfaces/peppol-item.interface';

export const PEPPOL_DIRECTION_CONFIG: Record<
  PeppolItemDirection,
  PeppolItemDirectionConfig
> = {
  [PeppolItemDirection.Incoming]: {
    icon: 'inbox_01',
    colorClass: 'secondary',
    label: 'PEPPOL.Inbox',
  },
  [PeppolItemDirection.Outgoing]: {
    icon: 'send_03',
    colorClass: 'secondary',
    label: 'PEPPOL.Outbox',
  },
};
